import { CSSProgressiveBody02Semibold } from "@caisy/league";
import styled from "styled-components";

export const SFileUploadEmptyTitle = styled.div`
  color: var(--text-01);
  ${CSSProgressiveBody02Semibold};
`;
